var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 6.65334C11.8965 6.39284 11.8961 5.97084 11.6356 5.71077C11.3751 5.4507 10.9531 5.45106 10.693 5.71156L7.76589 8.64359L6.53835 7.41605C6.27806 7.15576 5.85606 7.15576 5.59577 7.41605C5.33549 7.67633 5.33549 8.09834 5.59577 8.35862L7.29499 10.0578C7.42005 10.1829 7.58969 10.2531 7.76656 10.2531C7.94342 10.253 8.113 10.1826 8.23796 10.0574L11.6364 6.65334Z",
    fill: "#449711"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33317 0.666992C4.28317 0.666992 1 3.95016 1 8.00016C1 12.0502 4.28317 15.3333 8.33317 15.3333C12.3832 15.3333 15.6663 12.0502 15.6663 8.00016C15.6663 3.95016 12.3832 0.666992 8.33317 0.666992ZM2.333 8.00016C2.333 4.68636 5.01937 1.99999 8.33317 1.99999C11.647 1.99999 14.3333 4.68636 14.3333 8.00016C14.3333 11.314 11.647 14.0003 8.33317 14.0003C5.01937 14.0003 2.333 11.314 2.333 8.00016Z",
    fill: "#449711"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.b219d21aedac0141aa12cf7eedec6a3f.svg";
export { ForwardRef as ReactComponent };